module.exports = __webpack_public_path__ + "img/przelewy24.33d8e88.svg";